import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/layout/Sidebar';
import Dashboard from './pages/Dashboard';
import CRM from './pages/CRM';
import Courses from './pages/Courses';
import CourseEditor from './pages/CourseEditor';
import CoursePlayer from './pages/CoursePlayer';
import CourseEnrollments from './pages/CourseEnrollments';
import Sessions from './pages/Sessions';
import Messages from './pages/Messages';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Monetization from './pages/Monetization';
import Notifications from './pages/Notifications';
import CoachFlow from './pages/CoachFlow';
import Assessments from './pages/Assessments';
import Resources from './pages/Resources';
import AIArchitect from './pages/AIArchitect';
import Login from './pages/Login';
import DebugDashboard from './pages/DebugDashboard';
import GrowthEngine from './pages/GrowthEngine';
import StudentDashboardCustomizer from './pages/StudentDashboardCustomizer';
import { ToastProvider } from './components/layout/ToastProvider';
import NetworkStatus from './components/layout/NetworkStatus';
import ErrorBoundary from './components/common/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <Router>
          <NetworkStatus />
          <div className="flex min-h-screen bg-[#050505] text-white selection:bg-indigo-500/30">
            <Sidebar />
            <main className="flex-1 overflow-x-hidden">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/crm" element={<CRM />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/courses/edit/:id" element={<CourseEditor />} />
                <Route path="/courses/play/:id" element={<CoursePlayer />} />
                <Route path="/courses/enrollments/:id" element={<CourseEnrollments />} />
                <Route path="/sessions" element={<Sessions />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/monetization" element={<Monetization />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/automations" element={<CoachFlow />} />
                <Route path="/assessments" element={<Assessments />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/ai-architect" element={<AIArchitect />} />
                <Route path="/growth-engine" element={<GrowthEngine />} />
                <Route path="/student-dashboard" element={<StudentDashboardCustomizer />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/debug" element={<DebugDashboard />} />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </Router>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;